import { ResizeNotifier } from '@theme/utilities';
import { Component } from '@theme/component';

/**
 * Switches a horizontal USP list to a vertical stack when any item's text
 * would wrap onto a second line, so items never show partially wrapped text.
 */
class UspList extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#resizeObserver.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#resizeObserver.disconnect();
  }

  #checkWrap = () => {
    if (this.dataset.layout !== 'horizontal') return;

    // Disconnect while we mutate state, otherwise our own layout change re-triggers the observer.
    this.#resizeObserver.disconnect();
    this.removeAttribute('data-wrapped');

    const wrapped = Array.from(this.querySelectorAll('.usp-item__text')).some((text) => {
      if (!(text instanceof HTMLElement)) return false;
      const lineHeight = parseFloat(window.getComputedStyle(text).lineHeight);
      return lineHeight > 0 && text.scrollHeight > lineHeight * 1.5;
    });

    if (wrapped) {
      this.setAttribute('data-wrapped', 'true');
    }

    this.#resizeObserver.observe(this);
  };

  #resizeObserver = new ResizeNotifier(this.#checkWrap);
}

if (!customElements.get('usp-list')) {
  customElements.define('usp-list', UspList);
}
